import { useState, useMemo } from 'react';

interface PaginationOptions {
  data: any[];
  initialPage?: number;
  initialPageSize?: number;
}

export const usePagination = ({
  data,
  initialPage = 1,
  initialPageSize = 10,
}: PaginationOptions) => {
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return data.slice(startIndex, startIndex + pageSize);
  }, [data, currentPage, pageSize]);

  const totalPages = Math.ceil(data.length / pageSize);

  const goToPage = (page: number) => {
    setCurrentPage(Math.min(Math.max(1, page), totalPages));
  };

  return {
    currentPage,
    pageSize,
    paginatedData,
    totalPages,
    setPageSize,
    goToPage,
  };
};
